import { useNavigate } from "react-router-dom";
import moment from "moment";
import { Anchor, AppShell, Box, Group, Text } from "@mantine/core";
import { IconArrowRight } from "@tabler/icons-react";
import { useUserProvider } from "@/utils/UserProvider";

const NavbarFreeTrialSection = () => {
  const navigate = useNavigate();
  const { revcatUser } = useUserProvider();
  const activeEntitlements = (revcatUser as any).customerInfoApi?.entitlements
    .active;
  const allEntitlements = (revcatUser as any).customerInfoApi?.entitlements.all;
  if (
    Object.keys(activeEntitlements || {}).length === 0 &&
    Object.keys(allEntitlements || {}).length === 0
  ) {
    return null;
  }
  const hasSubscribed = Object.keys(allEntitlements || {}).find(
    (key) => allEntitlements[key].store !== "promotional",
  );
  if (!!hasSubscribed) {
    return null;
  }
  const activeSubscription =
    activeEntitlements["Premium"] || activeEntitlements["Essential"];

  if (activeSubscription && activeSubscription.store !== "promotional") {
    return null;
  }

  const premiumEntitlement = allEntitlements["Premium"];
  const expiredPromotion =
    premiumEntitlement &&
    premiumEntitlement.store === "promotional" &&
    new Date(premiumEntitlement?.expirationDate) < new Date();
  if (
    (!activeSubscription || activeSubscription?.store !== "promotional") &&
    !expiredPromotion
  ) {
    return null;
  }
  if (expiredPromotion && !activeSubscription) {
    return (
      <AppShell.Section>
        <Anchor
          onClick={() => {
            navigate(`/plans?upgrade=true`);
          }}
        >
          <Box
            bg={"#003554"}
            p={"xs"}
            mb={"sm"}
            style={{
              borderRadius: 10,
            }}
          >
            <Group gap={"xs"}>
              ⏰
              <Text c={"white"} size={"sm"} fw={500} w={"70%"}>
                Your free trial has expired. Subscribe to keep full access to
                Manta Classic
              </Text>
              <IconArrowRight size={"18"} color={"white"} />
            </Group>
          </Box>
        </Anchor>
      </AppShell.Section>
    );
  }
  return (
    <AppShell.Section>
      <Anchor
        onClick={() => {
          navigate(`/plans?upgrade=true`);
        }}
      >
        <Box
          bg={"#003554"}
          p={"xs"}
          mb={"sm"}
          style={{
            borderRadius: 10,
          }}
        >
          <Group gap={"xs"}>
            ⌛
            <Text c={"white"} size={"sm"} fw={500} w={"70%"}>
              Your free trial ends in{" "}
              {moment(activeSubscription.expirationDate).diff(moment(), "days")}{" "}
              days!
            </Text>
            <IconArrowRight size={"18"} color={"white"} />
          </Group>
        </Box>
      </Anchor>
    </AppShell.Section>
  );
};

export default NavbarFreeTrialSection;
